export const capitalizePlan = (plan) => {
  if (!plan) {
    return '';
  }
  return plan.charAt(0).toUpperCase() + plan.slice(1);
};
